import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  supportChat: {},
  supportChats: [],
  frequentlyAskedQuestions: undefined,
  tutorials: [],
};

export const HelpCenterSlice = createSlice({
  name: 'help-center',
  initialState,
  reducers: {
    setSupportChat: (state, action) => {
      state.supportChat = action.payload;
    },
    setSupportChats: (state, action) => {
      state.supportChats = action.payload;
    },
    setFrequentlyAskedQuestions: (state, action) => {
      state.frequentlyAskedQuestions = action.payload;
    },
    setTutorials: (state, action) => {
      state.tutorials = action.payload;
    },
    resetHelpCenterSlice: () => initialState,
  },
});

export const { setSupportChat, setSupportChats, setFrequentlyAskedQuestions, setTutorials, resetHelpCenterSlice } =
  HelpCenterSlice.actions;

export default HelpCenterSlice.reducer;
